import { TFunction, useTranslation } from "@impero-com/common/utils/i18n";
import * as z from "zod";

import { accessRightSchema } from "components/form/rhfFields/rhfAccessRights";
import { TestingProgramAccessRightsInstance } from "utils/accessRights/models";

import {
    useControlConclusionFieldArraySchema,
    useSampleConclusionFieldArraySchema,
} from "./components/ControlConclusionBuilder/schema";
import { useTestingProgramNameValidator } from "./hooks/useTestingProgramNameValidator";

const MAX_TITLE = 255;
const MAX_DESCRIPTION = 100000;

export const getNameSchema = (t: TFunction) =>
    z
        .string()
        .trim()
        .min(1, { error: t("Validation_Required") })
        .max(MAX_TITLE);
export const descriptionSchema = z.string().trim().max(MAX_DESCRIPTION);

export function useTestingProgramViewFormSchema(testingProgramId?: number) {
    const { t } = useTranslation();
    const isNameUnique = useTestingProgramNameValidator(testingProgramId);

    return z.object({
        name: getNameSchema(t).refine((name: string) => isNameUnique(name), {
            message: t("TestingProgramView_Name_NotUnique"),
        }),
        description: descriptionSchema,
        accessRights: accessRightSchema(TestingProgramAccessRightsInstance),
        controlConclusionTasks: useControlConclusionFieldArraySchema(),
        sampleConclusionTasks: useSampleConclusionFieldArraySchema(),
    });
}
export type TestingProgramFormSchema = z.infer<
    ReturnType<typeof useTestingProgramViewFormSchema>
>;
